import _indexOf from 'lodash.indexof';
import Vue from 'vue';

Vue.component('configurator-color-select', {
    props: {
        colors: {
            type: Array,
        },
        initialColor: {
            type: Object,
        },
    },

    data() {
        return {
            selectionExpanded: true,
            availableColors: [],
            color: null,
            colorExtraCost: '',
            colorExtraCostNotification: '',
            editionHandle: '',
            editionTitle: '',
            interiorHandles: [],
            isInteriorSelected: [],
            disabledColorSlugs: [],
            removedColor: false,
        };
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    watch: {
        /**
         * Send event on color change.
         *
         * @returns {Void}
         */
        color(value) {
            EventBus.$emit('configurator-set-color', value);
        },
    },
    beforeMount() {
        // This is hotfix for console error
        this.color = this.initialColor;
    },

    mounted() {
        // Set initial color.
        this.availableColors = this.colors;

        // Update color extra cost if a cost is emitted.
        EventBus.$on(
            'configurator-color-extra-cost',
            (extraCost, extraCostFormatted, showExtraCost, notification) => {
                this.colorExtraCost = '';
                this.colorExtraCostNotification = '';

                if (extraCost > 0 && showExtraCost) {
                    this.colorExtraCost = extraCostFormatted;

                    if (notification) {
                        this.colorExtraCostNotification = notification;
                    }
                }
            },
        );

        EventBus.$on('configurator-set-exclude-interior', (options) => {
            this.interiorHandles = [];
            this.isInteriorSelected = [];

            options.forEach((option) => {
                this.interiorHandles.push(option.field_optionHandle);
                this.isInteriorSelected.push(option.selected);
            });

            this.checkDisabledColors();
        });

        // Update editionHandle if edition changes.
        EventBus.$on('configurator-set-edition', (edition) => {
            this.editionHandle = edition.field_commerceHandle;
            this.editionTitle = edition.title;
            this.updateAvailableColors();
        });
    },

    methods: {
        handleSetButtonStyle(colorOption) {
            return {
                backgroundColor: colorOption.colorCode,
                backgroundImage: 'url(' + colorOption.colorImageUrl + ')',
            };
        },

        handleSetButtonColor(colorOption) {
            const buttonColorStyles = [`color-${colorOption.colorSlug}`];
            if (this.color && this.color.colorSlug == colorOption.colorSlug) {
                buttonColorStyles.push('active');
            }
            if (!this.isColorAvailable(colorOption)) {
                buttonColorStyles.push('configurator__colorpicker-color--disabled');
            }

            return buttonColorStyles;
        },

        handleSetColor(colorOption) {
            this.color = colorOption;
        },

        isColorAvailable(colorOption) {
            return !this.disabledColorSlugs.includes(colorOption.colorSlug);
        },

        checkDisabledColors() {
            this.updateAvailableColors();
            this.disabledColorSlugs = [];

            this.availableColors.forEach((color) => {
                if (!color.field_disableInteriorColors_gqcddajo) return;

                const parsedColorsWithEditions = JSON.parse(
                    color.field_disableInteriorColors_gqcddajo,
                );

                const arrayColorsWithEditions = parsedColorsWithEditions.map(
                    (colorWithEdition) => Object.values(colorWithEdition),
                );

                arrayColorsWithEditions.forEach((colorWithEditions) => {
                    const colorWithEdition = colorWithEditions[0];
                    const separatorIndex = colorWithEdition.indexOf('-');

                    if (separatorIndex === -1) return;

                    const disabledEdition = colorWithEdition.slice(
                        0,
                        separatorIndex,
                    );
                    const disabledColor = colorWithEdition.slice(
                        separatorIndex + 1,
                    );

                    if (
                        disabledEdition.toLowerCase() !==
                        this.editionTitle.toLowerCase()
                    ) {
                        return;
                    }

                    this.interiorHandles.forEach((interiorHandle, index) => {
                        if (!this.isInteriorSelected[index]) return;

                        if (disabledColor === interiorHandle) {
                            this.disabledColorSlugs.push(color.colorSlug);
                        }
                    });
                });
            });
        },

        updateAvailableColors() {
            // Loop colors to check which are available.
            this.availableColors = [];
            const filteredColors = this.colors.filter(
                (color) =>
                    _indexOf(color.outOfStock, this.editionHandle) === -1,
            );
            this.availableColors = this.handleColorsForMG4(filteredColors);

            this.handleUnavailableColor(this.availableColors);
        },

        handleColorsForMG4(colorsArray) {
            if (colorsArray.length === 0) return [];
            if (this.editionHandle === 'xpower') return colorsArray;

            return colorsArray.filter(
                (color) => color.colorSlug !== 'hunter-green',
            );
        },

        handleUnavailableColor(colorsArray) {
            const isSelectedColorInList = Boolean(
                colorsArray.find(
                    (color) => this.color.colorSlug === color.colorSlug,
                ),
            );
            if (isSelectedColorInList) return;

            this.color = this.availableColors[0];
        },
    },
});
